import React from "react";
import {ControlLabel, FormControl, FormGroup, HelpBlock, InputGroup} from "react-bootstrap";
import {Consumer} from "./CreateSigntask";
import { withTranslation } from 'react-i18next';

class Document extends React.Component {
  hasTitle = () => this.props.document.title.length > 0;
  hasFile = () => this.props.document.content.length > 0;

  missingTitle = () => !this.hasTitle() && this.hasFile();
  missingFile = () => this.hasTitle() && !this.hasFile();
  hasAllValues = () => this.hasTitle() && this.hasFile();
  nameTooShort = () => this.hasTitle() && this.props.document.title.length < 4;
  validationState = () => {
    if (this.missingTitle() || this.missingFile()) return "warning";
    if (this.nameTooShort()) return "warning";
    if (this.hasAllValues()) return "success";
  };

  onTitleChange = event => this.props.updateDocument({...this.props.document, title: event.target.value});
  onFileChange = event => {
    const file = event.target.files[0];

    const fileReader = new FileReader();
    fileReader.addEventListener("load", () => {
      const document = {...this.props.document, content: fileReader.result};

      if (!this.props.document.title) {
        document.title = file.name
          .replace(/^.*[\/\\]/, "") // Remove path
          .replace(/\.[^.]+$/, ""); // Remove file extension
      }

      this.props.updateDocument(document);
    });
    fileReader.readAsDataURL(file);
  };

  render () {
    const { t } = this.props;
    return(
      <FormGroup validationState={this.validationState()}>
        <InputGroup>
          <ControlLabel className="btn btn-default input-group-addon">
            {this.hasFile() ? t("create_signtask_document_choosen") : t("create_signtask_document_choose")} (#{this.props.number})
            <FormControl
              type="file"
              style={{display: "none"}}
              name={`${this.props.prefix}.Content`}
              onChange={this.onFileChange} />
          </ControlLabel>
          <FormControl
            type="text"
            placeholder={t("create_signtask_document_title")}
            name={`${this.props.prefix}.Title`}
            onChange={this.onTitleChange}
            value={this.props.document.title} />
        </InputGroup>
        {this.nameTooShort() ? <HelpBlock>Nets krever at dokumentnavnet er p� minst 4 tegn.</HelpBlock> : null}
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}

export default withTranslation()(({idx, ...props}) => (
  <Consumer>{({documents, updateDocument}) => (
    <Document
      {...props}
      number={idx + 1}
      prefix={`documents[${idx}]`}
      document={documents[idx]}
      updateDocument={updateDocument(idx)} />
  )}</Consumer>
));